export { default } from './ActorsCarousel';
